<div class="about-page">
  <div class="container">
    <!-- Loading State -->
    <div *ngIf="loading" class="loading-state">
      <div class="spinner"></div>
      <p>Caricamento...</p>
    </div>

    <!-- Error State -->
    <div *ngIf="error && !loading" class="error-state">
      <p>{{ error }}</p>
    </div>

    <!-- Content -->
    <div *ngIf="!loading && !error" class="about-content" [innerHTML]="content"></div>
  </div>
</div>
